var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHkIcFavourite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "26px",
    viewBox: "0 0 34 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Option-CardSystem-ShowOption-Copy",
    transform: "translate(-834.000000, -876.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keyboard-Indication",
    transform: "translate(520.000000, 877.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SupeLike",
    transform: "translate(314.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-4",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2631579,13.8157895 L16.4473684,13.8157895 L16.4473684,16.4473684 L9.86842105,12.5 L16.4473684,8.55263158 L16.4473684,11.1842105 L30.2631579,11.1842105 L30.2631579,-1.77635684e-15 L32.8947368,-1.77635684e-15 L32.8947368,13.8157895 L30.2631579,13.8157895 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#333333"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkIcFavourite);
export default __webpack_public_path__ + "static/media/hkIcFavourite.510eba256fdd3873f5170a429a89e793.svg";
export { ForwardRef as ReactComponent };